/* Braymont USA Updated — transparent optional merchant shipping protection.
 * One $2.95 service line; customer can remove by unchecking or in the cart.
 * Remember opt-out, never add alone, and don't open cart without interaction.
 */
(function(){
"use strict";
if(window.__brmShippingProtectionLoaded)return;
window.__brmShippingProtectionLoaded=true;
const PRODUCT=15271009517643,VARIANT=67370754703435,PRICE=295;
const STORAGE="brm_shipping_protection_preference_v1";
const base=()=>{const p=window.Shopify?.routes?.root||"/";return p.endsWith("/")?p:p+"/";};
const headers={"Content-Type":"application/json",Accept:"application/json","X-Requested-With":"XMLHttpRequest"};
let busy=false,queued=false,timer=null,lastSignature="",lastError="";
const pref=()=>{try{return localStorage.getItem(STORAGE)!=="off";}catch(e){return true;}};
function setPref(yes){try{localStorage.setItem(STORAGE,yes?"on":"off");}catch(e){}}
const countMerch=cart=>(cart.items||[]).filter(it=>Number(it.product_id)!==PRODUCT).reduce((n,it)=>n+Number(it.quantity||0),0);
function line(cart){return(cart.items||[]).filter(it=>Number(it.product_id)===PRODUCT);}
function currentPanel(){return document.querySelector("cart-drawer [data-brm-protection]");}
function setStatus(message,isError){
 const panel=currentPanel();if(!panel)return;
 panel.classList.toggle("is-error",!!isError);
 const status=panel.querySelector("[data-brm-protection-status]");
 if(status)status.textContent=message||"";
}
function drawState(cart,waiting=false){
 const panel=currentPanel();
 if(!panel)return;
 const merch=countMerch(cart)>0,added=line(cart).length>0;
 const wanted=pref();
 panel.hidden=!merch;
 panel.dataset.brmPresent=String(added);
 const checkbox=panel.querySelector("[data-brm-protection-toggle]");
 if(checkbox){
  checkbox.checked=wanted;
  checkbox.disabled=waiting;
 }
 panel.classList.toggle("is-loading",waiting);
 if(!merch){setStatus("",false);return;}
 setStatus(waiting?(wanted?"Adding protection…":"Removing protection…"):"",false);
}
async function cart(){
 const r=await fetch(base()+"cart.js",{credentials:"same-origin",cache:"no-store",headers:{Accept:"application/json"}});
 if(!r.ok)throw Error("Could not read your basket");
 return r.json();
}
async function change(url,data){
 const r=await fetch(base()+url,{method:"POST",headers,credentials:"same-origin",body:JSON.stringify(data)});
 const out=await r.json().catch(()=>({}));
 if(!r.ok||out.status)throw Error(out.description||out.message||"Could not update shipping protection");
 return out;
}
function themeId(){
 const s=new URLSearchParams(location.search).get("preview_theme_id")||String(window.Shopify?.theme?.id||"");
 return /^\d+$/.test(s)?s:"";
}
async function render(){
 const drawer=document.querySelector("cart-drawer");
 if(!drawer)return;
 const latest=await cart();
 const visibleCount=countMerch(latest);
 const bubble=document.querySelector("#cart-icon-bubble .cart-count-bubble span:not(.visually-hidden)");
 if(bubble)bubble.textContent=String(visibleCount);
 if(!drawer.classList.contains("active")){
  drawState(latest,false);
  return;
 }
 const query=new URLSearchParams({sections:"cart-drawer,cart-icon-bubble"});
 if(themeId())query.set("preview_theme_id",themeId());
 let sections=null;
 for(const path of ["cart",""]){
  try{
   const r=await fetch(base()+path+"?"+query.toString(),{credentials:"same-origin",cache:"no-store",headers:{Accept:"application/json"}});
   if(!r.ok)continue;
   const s=await r.json();
   const doc=new DOMParser().parseFromString(s?.["cart-drawer"]||"","text/html");
   if(doc.querySelector("#CartDrawer")&&typeof s?.["cart-icon-bubble"]==="string"){sections=s;break;}
  }catch(e){}
 }
 if(sections&&typeof drawer.renderContents==="function"){
  try{
   drawer.classList.remove("is-empty");
   drawer.querySelector(".drawer__inner")?.classList.remove("is-empty");
   drawer.renderContents({id:Number(latest.items?.find(x=>Number(x.product_id)!==PRODUCT)?.variant_id||VARIANT),sections});
  }catch(e){console.warn("[Braymont protection] drawer refresh fallback",e);}
 }
 const total=drawer.querySelector(".brm-checkout-price");
 if(total){
  try{total.textContent=new Intl.NumberFormat("en-US",{style:"currency",currency:latest.currency||"USD"}).format(latest.total_price/100);}catch(e){}
 }
 drawState(latest,false);
}
async function sync(force=false){
 if(busy){queued=true;return;}
 busy=true;
 try{
  let before=await cart();
  const merchandise=countMerch(before)>0;
  const protection=line(before);
  const wanted=merchandise&&pref();
  if(!force&&merchandise&&wanted&&protection.length===1&&Number(protection[0].quantity)===1){drawState(before);return;}
  drawState(before,true);
  let changed=false;
  if(!wanted||!merchandise){
   for(const item of protection){await change("cart/change.js",{id:item.key,quantity:0});changed=true;}
  }else if(protection.length===0){
   await change("cart/add.js",{items:[{id:VARIANT,quantity:1,properties:{"_Braymont Shipping Protection":"Optional order protection"}}]});
   changed=true;
  }else{
   // Any duplicates/quantities greater than 1 are corrected to exactly one.
   for(let i=0;i<protection.length;i++){
    const item=protection[i],target=i===0?1:0;
    if(Number(item.quantity)!==target){await change("cart/change.js",{id:item.key,quantity:target});changed=true;}
   }
  }
  before=changed?await cart():before;
  if(changed)await render();
  else drawState(before,false);
  lastError="";
  if(changed&&typeof publish==="function"&&typeof PUB_SUB_EVENTS!=="undefined"){
   try{publish(PUB_SUB_EVENTS.cartUpdate,{source:"brm-protection-sync",cartData:before});}catch(e){}
  }
 }catch(e){
  console.error("[Braymont protection] sync failed",e);
  lastError=String(e?.message||"Could not update protection");
  setStatus(lastError,true);
  const panel=currentPanel();
  if(panel)panel.querySelector("[data-brm-protection-toggle]")?.removeAttribute("disabled");
 }finally{
  busy=false;
  if(queued){queued=false;schedule(420);}
 }
}
function schedule(ms=600){
 if(timer)clearTimeout(timer);
 timer=setTimeout(()=>{timer=null;sync(false);},ms);
}
function eventChange(event){
 const checkbox=event.target.closest?.("[data-brm-protection-toggle]");
 if(!checkbox)return;
 setPref(checkbox.checked);
 setStatus(checkbox.checked?"Adding protection to your basket…":"Removing protection from your basket…",false);
 schedule(40);
}
function monitor(){
 const drawer=document.querySelector("cart-drawer");
 if(!drawer||drawer.dataset.brmProtectionObserved==="1")return;
 drawer.dataset.brmProtectionObserved="1";
 const observed=new MutationObserver(records=>{
  if(busy)return;
  if(records.some(r=>
    Array.from(r.addedNodes||[]).some(n=>n.nodeType===1&&
      (n.matches?.("cart-drawer-items,.cart-item,#CartDrawer-CartItems,.brm-shipping-protection")||
        n.querySelector?.(".brm-shipping-protection,#CartDrawer-CartItems,.cart-item"))))){
    const cb=currentPanel()?.querySelector("[data-brm-protection-toggle]");
    if(cb)cb.checked=pref();
    schedule(800);
  }
 });
 observed.observe(drawer,{childList:true,subtree:true});
}
function init(){
 monitor();
 const checkbox=currentPanel()?.querySelector("[data-brm-protection-toggle]");
 if(checkbox)checkbox.checked=pref();
 schedule(700);
}
document.addEventListener("change",eventChange);
document.addEventListener("click",event=>{
 const btn=event.target.closest?.("cart-remove-button,button.quantity__button,[data-brm-qty],#cart-icon-bubble");
 if(btn) {
  const lineEl=btn.closest?.(".cart-item");
  if(lineEl?.querySelector("[data-brm-insurance-line]"))setPref(false);
  schedule(800);
 }
},true);
if(typeof subscribe==="function"&&typeof PUB_SUB_EVENTS!=="undefined"){
 try{subscribe(PUB_SUB_EVENTS.cartUpdate,e=>{
  if(e?.source!=="brm-protection-sync")schedule(770);
 });}catch(e){}
}
window.BraymontProtection={sync,schedule};
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
window.addEventListener("pageshow",()=>schedule(900),{passive:true});
document.addEventListener("shopify:section:load",()=>{monitor();schedule(900);});
})();